import * as React from 'react';
import { intervalToDuration } from 'date-fns';
import { useNow } from '../../hooks/useNow';
import { useTranslation } from 'react-i18next';

type Props = {
  date: Date;
  className?: string;
};

const i18Path = 'date.unites';

export const TimeSince: React.FC<Props> = ({ date, className }) => {
  const { t } = useTranslation();
  const { now } = useNow(1000 * 60);

  const { years, months, days, hours, minutes } = intervalToDuration({
    start: date,
    end: now,
  });

  const text = (() => {
    if (years) return t(`${i18Path}.yearAgo`, { count: years });
    if (months) return t(`${i18Path}.monthAgo`, { count: months });
    if (days) return t(`${i18Path}.dayAgo`, { count: days });
    if (minutes) {
      const value = hours ? `${hours}h ${minutes}m` : `${minutes}m`;
      return t(`${i18Path}.timeAgo`, { value });
    }
    return t(`${i18Path}.justNow`);
  })();

  return <span className={className}>{text}</span>;
};
